<template>
	<div class="content">
	  <base-header class="pb-6">
		<div class="row align-items-center py-4">
		  <div class="col-lg-6 col-7">
			<h6 class="h2 text-white d-inline-block mb-0">
			  {{ $t("customer_information") }}
			</h6>
			<nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
			  <route-bread-crumb></route-bread-crumb>
			</nav>
		  </div>
		</div>
	  </base-header>
	  <div class="container-fluid mt--6">
		<div>
		  <card
			class="no-border-card"
			body-classes="px-0 pb-1"
			footer-classes="pb-2"
		  >
			<template slot="header">
			  <div class="row">
  
				<div class="form-group row">

					<div class="col-md-3">
						<base-input v-model="params.fname" :placeholder="$t('fname')"> </base-input>
					</div>

					<div class="col-md-3">
						<base-input v-model="params.lname" :placeholder="$t('lname')"> </base-input>
					</div>

					<div class="col-md-3">
						<base-input v-model="params.email" :placeholder="$t('email')"> </base-input>
					</div>

					<div class="col-md-3">
						<base-input v-model="params.phone" :placeholder="$t('phone')"> </base-input>
					</div>
				 
  
  
				  <div class="col-md-1">
					<base-button size="md" type="neutral" @click="SearchData()">
					  Search
					</base-button>
				  </div>
				</div>
			  </div>
			</template>
			<div>
			  <el-table
				:data="queriedData"
				row-key="id"
				header-row-class-name="thead-light"
				@sort-change="sortChange"
				@selection-change="selectionChange"
			  >
				<el-table-column min-width="200px"  :label="$t('name')">
				<div slot-scope="{ $index, row }" class="d-flex">
					{{ row.fname }} {{ row.lname }}
				</div>
				</el-table-column>

				<el-table-column min-width="200px"  :label="$t('phone')">
				<div slot-scope="{ $index, row }" class="d-flex">
					{{ row.phone }}
				</div>
				</el-table-column>

				<el-table-column min-width="200px"  :label="$t('email')">
				<div slot-scope="{ $index, row }" class="d-flex">
					{{ row.email }}
				</div>
				</el-table-column>

				<el-table-column min-width="200px"  :label="$t('address')">
				<div slot-scope="{ $index, row }" class="d-flex">
					{{ row.address[0].address_full }}
				</div>
				</el-table-column>
  
				<!-- <el-table-column
				  min-width="200px"
				  align="right"
				  :label="$t('actions')"
				>
				  <div slot-scope="{ $index, row }" class="d-flex">
					<base-button
					  @click.native="handleDetail($index, row)"
					  class="edit"
					  type="warning"
					  size="sm"
					  icon
					>
					  <i class="text-dtac-bt fa fa-edit"></i>
					  Detail
					</base-button>
				  </div>
				</el-table-column> -->
			  </el-table>
			</div>
			<div
			  slot="footer"
			  class=" col-12 d-flex justify-content-center justify-content-sm-between flex-wrap "
			  v-if="tableData.length != 0"
			>
			  <div class="">
				<p class="card-category">
				  {{ $t("data") }} {{ from + 1 }} {{ $t("to") }} {{ to }}
				  {{ $t("of") }}
				  {{ total }}
				  <span v-if="selectedRows.length">
					- &nbsp; &nbsp; {{ selectedRows.length }}
					{{ $t("row_select") }}
				  </span>
				</p>
			  </div>
			  <base-pagination
				class="pagination-no-border"
				v-model="pagination.currentPage"
				:per-page="pagination.perPage"
				:total="total"
			  >
			  </base-pagination>
			</div>
		  </card>
		</div>
	  </div>
  
	 
	</div>
  </template>
  <script>
  import { Table, TableColumn, Select, Option } from "element-ui";
  import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
  import { BasePagination } from "@/components";
  import clientPaginationMixin from "../PaginatedTables/clientPaginationMixin";
  import swal from "sweetalert2";
  import { mapGetters, mapActions } from "vuex";
  import flatPicker from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  export default {
	mixins: [clientPaginationMixin],
	components: {
	  flatPicker,
	  BasePagination,
	  RouteBreadCrumb,
	  [Select.name]: Select,
	  [Option.name]: Option,
	  [Table.name]: Table,
	  [TableColumn.name]: TableColumn,
	},
	computed: {
	  ...mapGetters({
		tableData: "Customer/getData",
	  }),
	},
	data() {
	  return {
		propsToSearch: ["fname", "lname", "phone", "email"],
		selectedRows: [],
		SearchKeyword: "",
		showAddModal: false,
		showInOutModal: false,

		params : {
			email : "",
			fname : "",
			lname : "",
			phone : "",
		},
		
		rowEdit: {
		  ID: 0,
		  Number: "",
		},
	  };
	},
	mounted() {
	  this.listData(this.params);
	},
	methods: {
	  ...mapActions({
		listData:"Customer/listData"
	  }),
	  SearchData() {
		this.listData(this.params);
	  },
  
	
	  selectionChange(selectedRows) {
		this.selectedRows = selectedRows;
	  },
	},
  };
  </script>
  <style>
  .no-border-card .card-footer {
	border-top: 0;
  }
  </style>
  